import {Component, OnInit} from '@angular/core';
import {ServerService, Server} from '../server.service';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Router} from '@angular/router';
import {NotificationService} from '../notification.service';

@Component({
  selector: 'app-server',
  templateUrl: './server.component.html',
  styleUrls: ['./server.component.css']
})
export class ServerComponent implements OnInit {

  data = new BehaviorSubject<Array<Server>>([]);
  searchText = new BehaviorSubject<string>('');

  dataToShow: Server[];

  searchFc = new FormControl();

  changeState = new Map<string, boolean>();

  disableDeletion = true;

  disableEditing = true;

  constructor(private ss: ServerService, private router: Router, private ns: NotificationService) {
  }

  changeSelection(id: string, state: boolean) {
    this.changeState.set(id, state);
    this.disableDeletion = true;
    this.disableEditing = true;
    let selectionCount = 0;
    this.changeState.forEach((value, key) => {
      if (value) {
        this.disableDeletion = false;
        selectionCount++;
      }
    });
    if (selectionCount === 1) {
      this.disableEditing = false;
    }
  }

  getSelection(id: string) {
    const value = this.changeState.get(id);
    if (value) {
      return value;
    } else {
      return false;
    }
  }

  getSelectedIds(): Array<string> {
    const returnValue: Array<string> = [];
    this.changeState.forEach((value, key) => {
      if (value) {
        returnValue.push(key);
      }
    });
    return returnValue;
  }

  filterData(t: string, s: Server[]): Server[] {
    return s.filter((server) => {
      for (let i in server) {
        if (server.hasOwnProperty(i)) {
          if (server[i].toString().indexOf(t) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  bulkDelete(ids: Array<string>) {
    let resultObservable: Observable<string> = Observable.from(new Array<string>());
    ids.forEach((id) => {
      resultObservable = resultObservable.concat(this.ss.remove(id));
    });
    resultObservable.subscribe(
      (id) => {
        console.log(`Id ${id} successfully deleted`);
        this.data.next(this.data.getValue().filter((server) => server.id !== id));
        this.changeSelection(id, false);
        this.ns.warning(id, 'Deletado com sucesso!');
      },
      (error) => {
        console.log(`error: ${error}`);
        this.ns.error(error.toString(), 'Erro ao deletar');
      }
    );
  }

  editData() {
    const selection = this.getSelectedIds();
    this.router.navigateByUrl('/servers/' + selection[0]);
  }

  ngOnInit() {
    this.ss.getAll().subscribe((servers: Server[]) => this.data.next(servers));
    this.searchFc.valueChanges.debounceTime(250).subscribe((text) => {
      this.searchText.next(text);
      this.dataToShow = this.filterData(text, this.data.getValue());
    });
    this.data.subscribe((servers: Array<Server>) => {
      this.dataToShow = this.filterData(this.searchText.getValue(), servers);
    });
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/server/server.component.ts